import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/sections/Footer';
import { ScrollReveal } from '@/components/effects/ScrollReveal';

export default function LegalLayout({ eyebrow, title, lastUpdated = 'April 2026', children, testId }) {
  return (
    <div
      data-testid={testId}
      style={{ background: 'var(--bg)', minHeight: '100vh', color: 'var(--white)' }}
    >
      <Navbar />

      {/* Hero */}
      <section
        className="relative pt-32 pb-14 sm:pt-40 sm:pb-20 border-b"
        style={{ background: 'var(--bg)', borderColor: 'var(--b1)' }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'radial-gradient(ellipse 70% 50% at 60% 30%, rgba(139,92,246,0.08) 0%, transparent 60%)',
          }}
        />
        <div className="relative max-w-[860px] mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollReveal>
            {eyebrow && (
              <p
                className="font-body text-xs uppercase tracking-[0.22em] mb-3"
                style={{ color: 'var(--a)' }}
              >
                {eyebrow}
              </p>
            )}
            <h1
              className="font-display font-extrabold tracking-[-0.03em] mb-4"
              style={{ fontSize: 'clamp(2rem, 4.5vw, 3.2rem)', color: 'var(--white)' }}
            >
              {title}
            </h1>
            <p
              className="font-body text-sm"
              style={{ color: 'var(--ts)' }}
            >
              Last updated: {lastUpdated}
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Body */}
      <section className="py-14 sm:py-20" style={{ background: 'var(--bg)' }}>
        <div className="max-w-[860px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="legal-prose">
            {children}
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        .legal-prose { font-family: var(--fb); color: rgba(240,237,248,0.82); line-height: 1.75; }
        .legal-prose h2 {
          font-family: var(--fd);
          font-weight: 700;
          letter-spacing: -0.02em;
          color: var(--white);
          font-size: clamp(1.35rem, 2.4vw, 1.75rem);
          margin-top: 2.5rem;
          margin-bottom: 0.9rem;
        }
        .legal-prose h2:first-child { margin-top: 0; }
        .legal-prose h3 {
          font-family: var(--fd);
          font-weight: 600;
          color: var(--white);
          font-size: 1.05rem;
          margin-top: 1.6rem;
          margin-bottom: 0.6rem;
        }
        .legal-prose p { margin-bottom: 1rem; font-size: 0.98rem; }
        .legal-prose ul { list-style: disc; padding-left: 1.25rem; margin-bottom: 1rem; }
        .legal-prose li { margin-bottom: 0.45rem; font-size: 0.98rem; }
        .legal-prose a { color: var(--a-bright); text-decoration: underline; text-underline-offset: 3px; }
        .legal-prose a:hover { color: var(--violet); }
        .legal-prose strong { color: var(--white); font-weight: 600; }
        .legal-prose hr {
          border: 0;
          border-top: 1px solid var(--b1);
          margin: 2rem 0;
        }
        .legal-prose .legal-table-wrap {
          overflow-x: auto;
          margin: 1.25rem 0 1.5rem;
          border-radius: 8px;
          border: 1px solid var(--b1);
        }
        .legal-prose table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.92rem;
          background: rgba(10,10,18,0.55);
        }
        .legal-prose thead {
          background: rgba(139,92,246,0.08);
        }
        .legal-prose th {
          font-family: var(--fd);
          font-weight: 600;
          color: var(--white);
          text-align: left;
          padding: 0.75rem 1rem;
          border-bottom: 1px solid var(--b2);
          letter-spacing: -0.005em;
          font-size: 0.88rem;
        }
        .legal-prose td {
          padding: 0.75rem 1rem;
          border-bottom: 1px solid var(--b1);
          color: rgba(240,237,248,0.78);
          vertical-align: top;
          line-height: 1.6;
        }
        .legal-prose tr:last-child td { border-bottom: none; }
      `}</style>
    </div>
  );
}
